import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types/enums';
import { useTranslations } from 'next-intl';
import styles from './DirectDepositInfo.module.css';
function DirectDepositInfo(t0) {
  const $ = _c(4);
  const {
    paymentMethod
  } = t0;
  const t = useTranslations();
  if (paymentMethod !== PaymentMethods.DirectDeposit) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("nextjs.donate.direct_deposit_info");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles.directDepositCard}><p className={styles.directDepositText}>{t1}</p></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export default DirectDepositInfo;